export default "__VITE_ASSET__77f02fd9__"